/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import classNames from 'classnames'
import { ReactComponent as PlusIcon } from '@svgs/illustration/plus.svg'
import { SizingWidgetItem } from '@helpers/products/sizingWidgetData'
import styles from './styles.module.scss'

type SizingItemMobileProps = {
  item: SizingWidgetItem
  onClick: () => void
  order: number
  moveStyle: string
}

function SizingItemMobile({
  item: { title, imageCard },
  onClick,
  order,
  moveStyle
}: SizingItemMobileProps) {
  const preloadImage = () => {
    const prelaodedImage = new Image()
    prelaodedImage.src = imageCard.file.url
    return prelaodedImage.src
  }

  const itemStyle = {
    backgroundImage: `url(${preloadImage()})`
  }

  const classes = classNames(
    `
    ${styles.sizingItemMobile}
    ${styles.sizingItemMobile__card}
    sizing-item-mobile-card
    sizing-item-mobile-card-${order}
    ${moveStyle}`
  )
  return (
    <div className={classes} style={itemStyle}>
      <div className={styles.sizingItemMobile__content} onClick={onClick}>
        <h3 className={styles.sizingItemMobile__title}>{title}</h3>
        <div className={styles.sizingItemMobile__icon}>
          <PlusIcon />
        </div>
      </div>
    </div>
  )
}

export default SizingItemMobile
